module.exports = __webpack_public_path__ + "img/front-card.ac773a6a.png";